<template>
  <div class="curve-container">
    <CurveLowLeft
      v-if="curveAlignment === 'left' && !inverse"
      class="curve curve-left"
      :class="[svgColorClass, bgColorClass]"
    />
    <CurveLowLeftInverse
      v-if="curveAlignment === 'left' && inverse"
      class="curve curve-left"
      :class="[svgColorClass, bgColorClass]"
    />
    <CurveLowRight
      v-if="curveAlignment === 'right'"
      class="curve curve-right"
      :class="[svgColorClass, bgColorClass]"
    />
    <CurveHeaderBottom
      v-if="curveIsBig"
      class="curve curve-header"
      :class="svgColorClass"
    />
  </div>
</template>

<script>


export default {
  name: 'KfCurve',
  components: {
    CurveLowLeftInverse: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CurveLowLeftInverse.vue'),
    CurveLowRight: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CurveLowRight.vue'),
    CurveLowLeft: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CurveLowLeft.vue'),
    CurveHeaderBottom: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CurveHeaderBottom.vue'),
  },
  props: {
    inverse: {
      type: Boolean,
      default: false,
    },
    curveAlignment: {
      type: String,
      default: null,
    },
    curveSvgColor: {
      type: String,
      default: '',
    },
    curveBgColor: {
      type: String,
      default: '',
    },
    curveIsBig: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    svgColorClass() {
      return this.curveSvgColor ? `is-svg-${this.curveSvgColor.toLowerCase()}` : null;
    },
    bgColorClass() {
      return this.curveBgColor ? `is-bg-${this.curveBgColor.toLowerCase()}` : null;
    },
  },
};
</script>

<style lang="postcss">
.curve-container {
  padding-bottom: 9.517vw;
  overflow: hidden;
  position: relative;

  .curve {
    @apply bg-transparent text-white;
    position: absolute;
    top: 0;
    height: 100%;
    max-width: initial;
    width: 100vw;

    &.is-svg-gray {
      @apply text-gray-50;
    }

    &.is-svg-white {
      @apply text-white;
    }

    &.is-bg-gray {
      @apply bg-gray-50;
    }

    &.is-bg-white {
      @apply bg-white;
    }
  }
}
</style>
